<template>
    <section class="company-hierarchy">
        <div v-if="isImpersonating" class="alert alert-info mb-3">
            <i class="fa fa-info-circle"></i>
            Viewing as: <strong>{{ currentCompanyName }}</strong>
        </div>

        <ul class="hierarchy-tree">
            <hierarchy-node
                v-for="item in hierarchy"
                :key="item.id"
                :item="item"
                :current-company-id="currentCompanyId"
                @switch-to="switchTo"
            ></hierarchy-node>
        </ul>
    </section>
</template>

<script>
import HierarchyNode from './HierarchyNode.vue';

export default {
    components: {
        HierarchyNode
    },

    props: {
        hierarchy: {
            type: Array,
            required: true
        },
        actualCompanyId: {
            type: Number,
            required: true
        },
        actualCompanyName: {
            type: String,
            required: true
        },
        currentCompanyId: {
            type: Number,
            required: true
        },
        currentCompanyName: {
            type: String,
            required: true
        },
        isImpersonating: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        async switchTo(item) {
            try {
                const response = await fetch(`${localized.resturl}/company/switch`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-WP-Nonce': localized.restnonce
                    },
                    body: JSON.stringify({ company_id: item.id })
                });

                const result = await response.json();

                if (result.success) {
                    window.location.reload();
                } else {
                    toastr.error(result.message || 'Failed to switch company', 'Error');
                }
            } catch (error) {
                toastr.error('Failed to switch company', 'Error');
            }
        },

    }
}
</script>
